'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var treeViewItemComponent = exports.treeViewItemComponent = {
    template: require('./tree-view-item.html'),
    bindings: {
        category: '<',
        changeFilters: '&',
        level: '<',
        item: '<',
        isLink: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.treeViewOpen = vm.item.isSelected || vm.item.childSelected ? true : false;
        vm.getLevel = getLevel;
        vm.onChangeFilters = onChangeFilters;
        vm.openTreeView = openTreeView;

        function getLevel() {
            return parseInt(vm.level) + 1;
        }

        function onChangeFilters($event) {
            vm.changeFilters({ $event: $event });
        }

        function openTreeView() {
            vm.treeViewOpen ? vm.treeViewOpen = false : vm.treeViewOpen = true;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/common/tree-view-item.js
// module id = 923
// module chunks = 0